import BlogSixContainer from "./container/BlogSixContainer";
export default BlogSixContainer;
